import { Colors, Loading } from '@helloself/hello-self-ui';
import React from 'react';

import { SubmitError } from './SubmitError';
import { SubmitSuccess } from './SubmitSuccess';

interface SubmitStatusProps {
    isSubmitting: boolean;
    status?: {
        success: boolean;
        errorMessage?: string;
    };
}

export function SubmitStatus({ isSubmitting, status }: SubmitStatusProps) {
    if (isSubmitting) {
        return <Loading color={Colors.white} />;
    } else if (status?.success) {
        return <SubmitSuccess />;
    } else if (status?.success === false) {
        return <SubmitError errorMessage={status?.errorMessage || ''} />;
    } else {
        return null;
    }
}
